import { useState } from 'react';

export const useHover = () => {
  const [active, setActive] = useState(false);

  return {
    active,
    bind: {
      onMouseEnter: () => setActive(true),
      onMouseLeave: () => setActive(false),
    },
  };
};
